import { ApiResponse } from '../../types'
import client from '../../client'
import { CampaignBanner } from './types'

export * from './types'

export const list = async () => {
  const { data }: ApiResponse<CampaignBanner[]> = await client.get(
    '/user/campaignBanners'
  )
  return data
}
